import { render, staticRenderFns } from "./feefo-stars.vue?vue&type=template&id=1ecf292e&scoped=true&lang=pug&"
import script from "./feefo-stars.vue?vue&type=script&lang=js&"
export * from "./feefo-stars.vue?vue&type=script&lang=js&"
import style0 from "./feefo-stars.vue?vue&type=style&index=0&id=1ecf292e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecf292e",
  null
  
)

export default component.exports